import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

// Shown instead of the app when a DBA has reset this person's password to a
// temporary one (user_metadata.must_change_password). Saving a new password
// clears the flag; Supabase then refreshes the session and the app opens.
const MIN_PASSWORD = 8;

export default function ChangePasswordScreen({ email, onSignOut }) {
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function save(e) {
    e.preventDefault();
    setError('');
    if (pw.length < MIN_PASSWORD) { setError(`Use at least ${MIN_PASSWORD} characters.`); return; }
    if (pw !== confirm) { setError('The two passwords do not match.'); return; }
    setSaving(true);
    const { error: err } = await supabase.auth.updateUser({ password: pw, data: { must_change_password: false } });
    setSaving(false);
    if (err) setError(/different from the old/i.test(err.message) ? 'Choose a password different from the temporary one.' : err.message);
  }

  const input = { width:'100%', padding:'10px 12px', border:'1px solid rgba(0,0,0,0.12)', borderRadius:8, fontSize:14, boxSizing:'border-box', marginTop:4 };
  return (
    <div style={{ minHeight:'100vh', background:'var(--deep)', display:'flex', alignItems:'center', justifyContent:'center', padding:20, fontFamily:'Inter,Arial,sans-serif' }}>
      <form onSubmit={save} style={{ background:'var(--surface)', borderRadius:18, padding:'34px 32px', width:'100%', maxWidth:400, boxShadow:'0 32px 80px rgba(0,0,0,0.35)' }}>
        <div style={{ fontFamily:'Plus Jakarta Sans,sans-serif', fontSize:19, fontWeight:800, color:'var(--navy)' }}>Choose a new password</div>
        <div style={{ fontSize:13.5, color:'var(--slate)', margin:'6px 0 20px', lineHeight:1.5 }}>
          You signed in with a temporary password{email ? ` for ${email}` : ''}. Set your own password to continue.
        </div>
        {error && <div style={{ background:'var(--rp)', color:'var(--r-ink)', padding:'9px 12px', borderRadius:8, fontSize:13.5, marginBottom:14 }}>{error}</div>}
        <label style={{ fontSize:12.5, fontWeight:700, color:'var(--ink2)' }}>New password
          <input type="password" autoComplete="new-password" value={pw} onChange={e=>setPw(e.target.value)} style={input} autoFocus/>
        </label>
        <div style={{ height:12 }}/>
        <label style={{ fontSize:12.5, fontWeight:700, color:'var(--ink2)' }}>Confirm new password
          <input type="password" autoComplete="new-password" value={confirm} onChange={e=>setConfirm(e.target.value)} style={input}/>
        </label>
        <button type="submit" disabled={saving} style={{ width:'100%', marginTop:20, padding:'11px', border:'none', borderRadius:9, background:'linear-gradient(135deg,#F5A623,#E8860A)', color:'var(--deep)', fontWeight:800, fontSize:14, cursor:'pointer' }}>
          {saving ? 'Saving...' : 'Save and continue'}
        </button>
        <button type="button" onClick={onSignOut} style={{ width:'100%', marginTop:10, padding:'9px', border:'none', background:'none', color:'var(--slate2)', fontSize:13.5, cursor:'pointer' }}>Sign out</button>
      </form>
    </div>
  );
}
